import _ from 'lodash'

export function isCordovaAvailableListener () {
    return Promise.resolve((window as any).cordova && _.isFunction((window as any).cordova.exec))
}
